<template>
    <div style="height: 140px;">
        <div class="w-100 step-title v-flex" >
            <div
                class = "primary--text"
                style = "margin-bottom: 0; padding-top:  16px;"
            >
                {{ $t('contract.payment.title') }}
            </div>
            <v-checkbox
                v-model   = "contract.invoiceInAdvance"
                label     = "im Voraus"
                :ripple   = "false"
                :readonly = "true"
                style     = "margin-top: 11px"
                hide-details
            />
        </div>
        <v-row class="no-frame">
            <v-col class="no-frame pr-2 col-7">
                <f-read-only-field
                    v-if="contract.invoiceFrequency"
                    class  = "w-100 mt-1"
                    :dense = "true"
                    label  = "Frequenz"
                    :value = "contract.invoiceFrequency ? contract.invoiceFrequency.name : null"
                    color  = "pt-0-5 pl-1 ro-background"
                />
            </v-col>
            <v-col class="no-frame pl-2">
                <v-row class="no-frame"  >
                    <v-col class="col-3 no-frame pr-2">
                        <f-read-only-field
                            v-if   = "contract.invoiceFrequency && contract.invoiceFrequency.id !== 1"
                            class  = "w-100 mt-1"
                            :dense = "true"
                            label  = "Tag"
                            :value = "contract.invoiceDay"
                            color  = "pt-0-5 pl-1 ro-background"
                        />
                    </v-col>
                    <v-col class="col-9 no-frame pl-2">
                        <f-read-only-field
                            v-if   = "contract.invoiceFrequency && contract.invoiceFrequency.id !== 2 && contract.invoiceFrequency.id !== 1"
                            class  = "w-100 mt-1"
                            :dense = "true"
                            label  = "Monat"
                            :value = "contract.invoiceMonth ? contract.invoiceMonth : null"
                            color  = "pt-0-5 pl-1 ro-background"
                        />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="no-frame mt-2" v-if="contract.invoiceFrequency && contract.invoiceFrequency.id !== 1 && contract.invoiceFrequency.id !== 2">
            <f-read-only-field
                class  = "w-100"
                label  = "Termine"
                :value = "deadline"
                color  = "pt-0-5 pl-1 ro-background"
            />
        </v-row>
    </div>
</template>

<script>

import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField";
import Msd from "@/modules/msd/common/service/Msd";

export default {
    name: "PSiteContractPayment",
    components: {
        FReadOnlyField
    },

    props: {
        contract: {
            required: true,
            type    : Object,
            default : function () {
                return {
                    invoiceInAdvance: null,
                    invoiceDay      : null,
                    invoiceMonth    : null,
                    invoiceFrequency: null
                }
            },
        },
    },

    data: () => ({
        deadline: null,
    }),

    computed: {
        months () {
            return this.$store.getters.month;
        },
    },

    mounted() {
        this.onRecalculate();
    },

    watch: {
        contract: {
            deep: true,
            handler: function () {
                this.onRecalculate();
            }
        }
    },

    methods: {
        onRecalculate () {
            if (!this.contract.invoiceFrequency || this.contract.invoiceFrequency.id < 3) {
                this.deadline = null;
            } else {
                this.deadline = Msd.contract.mnt.deadlines(this.contract, this.months);
            }
        }
    }
}
</script>

<style scoped>

</style>